import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core'
import { ActivatedRoute } from '@angular/router'
import { CreateAccountService } from '../../services/create-account.service'

@Component({
  selector: 'app-create-account-shell',
  templateUrl: './create-account-shell.component.html',
  styleUrls: ['./create-account-shell.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class CreateAccountShellComponent implements OnInit {
  constructor(
    public createAccountService: CreateAccountService,
    private activatedRoute: ActivatedRoute
  ) {}

  ngOnInit() {
    // Setting these fields from the query parameters is mainly a helper for testing the
    // create account flow. But we could use it for e.g. sending deep links to customers.
    this.activatedRoute.queryParamMap.subscribe((paramMap) => {
      if (paramMap.has('createdAccountId')) {
        this.createAccountService.createdAccountId = paramMap.get('createdAccountId')
        console.log(`Set createdAccountId to ${this.createAccountService.createdAccountId}`)
      }
      if (paramMap.has('nativeAuthToken')) {
        this.createAccountService.nativeAuthToken = paramMap.get('nativeAuthToken')
        console.log(`Set nativeAuthToken to ${this.createAccountService.nativeAuthToken}`)
      }
      if (paramMap.has('accountCreator')) {
        this.createAccountService.accountCreator = paramMap.get('accountCreator')
        console.log(`Set accountCreator to ${this.createAccountService.accountCreator}`)
      }
    })
    this.activatedRoute.paramMap.subscribe((paramMap) => {
      // capture the entitlement token if it was passed via the navigationExtras.state
      // field when we navigated here.
      if (!!window.history.state && !!window.history.state.entitlementToken) {
        this.createAccountService.entitlementToken = window.history.state.entitlementToken
      }
    })
  }
}
